import moment from 'moment'
import React, { FC, Suspense } from 'react'
import { Circle, Home, User } from 'react-feather'
import { Route, RouteProps, Switch } from 'react-router'
import { BrowserRouter as Router } from 'react-router-dom'
import { FillLoader, SideBar } from '../components'
import Loader from '../components/FillLoader'
import { P } from '../components/Typography'
import PageNotFound from '../containers/PageNotFound'
import { useAuthentication } from '../hooks'
import { theme } from '../theme'
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from './routes'

interface RouteType extends RouteProps {
  component: any
  title: string
}

const NAV_ITEMS = [
  {
    to: '/',
    title: 'Dashboard',
    icon: <Home size={20} color="white" className="sidebar-menu-icon" />
  },
  {
    to: '/user-setup',
    title: 'User Setup',
    icon: <User size={20} color="white" className="sidebar-menu-icon" />
  },
  {
    to: '/warehouse-setup',
    title: 'Warehouse Setup',
    icon: <Circle size={20} color="white" className="sidebar-menu-icon" />
  },
  {
    to: '/storage-type-setup',
    title: 'Storage Type Setup',
    icon: <Circle size={20} color="white" className="sidebar-menu-icon" />
  },
  {
    to: '/order-entry',
    title: 'Order Entry',
    icon: <Circle size={20} color="white" className="sidebar-menu-icon" />
  }
]

const Redirect: FC<{ redirectFn: () => void }> = ({ redirectFn }) => {
  redirectFn()
  return null
}

const PrivateRoute = ({ component: Component, ...rest }: RouteType) => {
  const { authenticating, isAuthenticated, signInRedirect } = useAuthentication()

  if (authenticating) {
    return <Loader />
  }

  if (isAuthenticated) {
    return (
      <Route {...rest}>
        <SideBar
          mode="push"
          color="white"
          bg="gray.800"
          navItems={NAV_ITEMS}
          hovercolor={theme.colors.gray[500]}
          accentcolor={theme.colors.gray[500]}
        >
          <React.Suspense fallback={<FillLoader bg="gray.50" />}>
            <Component />
          </React.Suspense>
        </SideBar>
      </Route>
    )
  }

  return <Redirect redirectFn={signInRedirect} />
}

const PublicRoute = ({ component: Component, ...rest }: RouteType) => (
  <Route {...rest}>
    <Component />
    <P textAlign="center" width="100%" paddingY={2} fontSize="sm" marginTop="-48px">
      Copyright &copy; {moment().year()} MACS Software
    </P>
  </Route>
)

const Navigation = () => (
  <Router>
    <Suspense fallback={<FillLoader />}>
      <Switch>
        {PUBLIC_ROUTES.map((route) => {
          return <PublicRoute key={route.path} {...route} />
        })}
        {PRIVATE_ROUTES.map((route) => {
          return <PrivateRoute key={route.path} {...route} />
        })}
        <Route render={PageNotFound} />
      </Switch>
    </Suspense>
  </Router>
)

export default Navigation
